import React from 'react';
import { NotificationSettings } from '../../shared/NotificationSettings';

/**
 * Recruiter notification preferences.
 *
 * This used to be a standalone mock (its "save" was a fake setTimeout, never
 * persisted anywhere - see git history). The shared NotificationSettings
 * component already talks to the real GET/PUT /api/notifications/preferences
 * endpoints and the notification_preferences table; it just wasn't imported
 * anywhere. This page is now a thin wrapper around it so recruiter
 * notification channel preferences are genuinely real, which the
 * candidate-update-request routing (see Phase 3) depends on.
 */
const Notifications = () => (
  <div className="space-y-6">
    <div>
      <h2 className="text-2xl font-bold">Notifications</h2>
      <p className="text-muted-foreground">
        Choose how you want to be notified about activity in the portal
      </p>
    </div>
    <NotificationSettings />
  </div>
);

export default Notifications;
